import { CpaSearchSuggestModel, CpaProductsSuggestDto } from '../../data-layer/cpa/types';

export const toCpaProductsSuggestModel = (dto: CpaProductsSuggestDto): CpaSearchSuggestModel[] =>
    dto.texts
        .map((item) => ({
            text: item.text,
        }))
        .concat(dto.objects.map((item) => ({ text: item.name, icon: item.image })));
